import { SimpleMenu } from "@kaltura/mediaspace-shared-ui";
import { useState } from "react";
import { getComponentFromPath, translate, useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { ButtonClickAnalyticsType, KmsTypeComponent } from "@kaltura/mediaspace-shared-types";
import { Button } from "@kaltura/ds-react-components";
import { MoreVertical24Icon } from "@kaltura/ds-react-icons";
import { ButtonAnalyticsProvider, useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { useTheme } from "@kaltura/mediaspace-shared-styled";

export interface ActionsMenuProps {
    isChannel: boolean;
    actions: KmsTypeComponent[];
}

/**
 * Category actions menu
 */
const ActionsMenu = (props: ActionsMenuProps) => {
    const { isChannel, actions } = props;

    const [closeMenu, setCloseMenu] = useState<boolean>(false);

    const sendButtonAnalytics = useButtonAnalytics();
    const theme = useTheme();
    const isXsScreenOrBellow = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.xs));

    if (actions.length === 0) {
        return null;
    }

    return (
        <SimpleMenu
            id={"categoryActions"}
            button={
                <Button
                    variant={"borderless"}
                    startIcon={<MoreVertical24Icon />}
                    value={translate("Actions")}
                    color={"secondary"}
                >
                    {isXsScreenOrBellow ? "" : translate("Actions")}
                </Button>
            }
            className={"kms-ds-channel-page-actions-menu-button"}
            close={closeMenu}
            onOpen={() => {
                sendButtonAnalytics(`${isChannel ? "Channel" : "Gallery"} actions menu`, ButtonClickAnalyticsType.OPEN);
                setCloseMenu(false);
            }}
        >
            <ButtonAnalyticsProvider location={`Menu - ${isChannel ? "Channel" : "Gallery"} actions`}>
                {actions.map(({ component, props }, index) => {
                    const Component = getComponentFromPath(component);
                    return <Component key={index} {...props} onCloseMenu={() => setCloseMenu(true)} />;
                })}
            </ButtonAnalyticsProvider>
        </SimpleMenu>
    );
};

export default ActionsMenu;
